import React, { useEffect, useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Slider from '@material-ui/core/Slider';
import { styled } from '@material-ui/core/styles';

const marks = [
  {
    value: 0,
    label: 'Progress.',
  },
    {
    value: 100,
    label: '% complete.',
  },
];

//const PrettoSlider = styled(Slider)({
//    height: 15,
//    width: "90%",
//    marginLeft: 20,
//    justify: "center",
//    '& .MuiSlider-thumb': {
//      height: 21,
//      width: 21,
//      backgroundColor: '#fff',
//      border: '2px solid currentColor',
//      marginTop: -9,
//      marginLeft: -9,
//      '&:focus, &:hover, &.Mui-active': {
//        boxShadow: 'inherit',
//      },
//    },
//    '& .MuiSlider-valueLabel': {
//      left: 'calc(-25% + 4px)',
//      scale: (0.01)
//    },
//    '& .MuiSlider-track': {
//      height: 15,
//      borderRadius: 4,
//      opacity: 0.01,
//      
//    },
//    '& .MuiSlider-rail': {
//      height: 15,
//      borderRadius: 4,
//      marginTop: -6,
//      marginLeft: -10,
//      backgroundColor: "#002D55"
//      width: "105%"
//    },
//  });


function getSymptomColor(symptomStatus) {
  // symptomStatus: 'green', 'yellow', 'red', or undefined
  if (symptomStatus === 'green') return '#4CAF50'; // Green
  if (symptomStatus === 'yellow') return '#FFC107'; // Yellow
  if (symptomStatus === 'red') return '#F44336'; // Red
  // If not provided, pick random
  const colors = ['#4CAF50', '#FFC107', '#F44336'];
  return colors[Math.floor(Math.random() * colors.length)];
}

const PrettoSlider = withStyles({
  root: {
    height: 8,
    minHeight: 8,
    padding: '0 4px',
    width: 80,
    minWidth: 80,
    maxWidth: 80,
  },
  thumb: {
    display: 'none', // hide thumb
  },
  track: {
    height: 8,
    borderRadius: 4,
    backgroundColor: (props) => getSymptomColor(props.symptomStatus),
  },
  rail: {
    height: 8,
    borderRadius: 4,
    opacity: 0.7,
    backgroundColor: 'rgba(220,220,220,0.7)', // light grey, slightly transparent
  },
  mark: {
    display: 'none', // hide marks
  },
  markActive: {
    display: 'none', // hide active marks
  },
  valueLabel: {
    display: 'none', // hide value label
  },
})(Slider);

function valuetext(value) {
  return `{value} %`;
}

export default function DiscreteSlider(props) {
  const [symptomStatus, setSymptomStatus] = useState(props.symptomStatus);

  useEffect(() => {
    // If symptomStatus is not provided, pick random once
    if (!props.symptomStatus) {
      setSymptomStatus(getSymptomColor());
    } else {
      setSymptomStatus(props.symptomStatus);
    }
  }, [props.symptomStatus]);

  return (
    <div style={{ width: 40, minWidth: 40, maxWidth: 40 }}>
      <PrettoSlider
        defaultValue={100}
        step={1}
        value={100}
        disabled
        min={0}
        max={100}
        symptomStatus={symptomStatus}
      />
    </div>
  );
}
